import { AnoNe, CsEnNazev, CsEnPopis } from "b2b/renderers";

export const id = () => ({
  id: "id",
  label: "b2b.zdroje-grid-columns.id.label",
  path: "id"
});
export const nazev = () => ({
  id: "nazevCs",
  label: "b2b.zdroje-grid-columns.nazev.label",
  path: "",
  renderer: CsEnNazev
});
export const popis = () => ({
  id: "popis",
  label: "b2b.zdroje-grid-columns.popis.label",
  path: "",
  renderer: CsEnPopis
});
export const exkluzivita = () => ({
  id: "exkluzivita",
  label: "b2b.zdroje-grid-columns.exkluzivita.label",
  path: "exkluzivita",
  renderer: AnoNe
});
export const maxPocetPozadavku = () => ({
  id: "maxPocetPozadavku",
  label: "b2b.zdroje-grid-columns.maxPocetPozadavku.label",
  path: "maxPocetPozadavku"
});
export const pozadavekSmena = () => ({
  id: "pozadavekSmena",
  label: "b2b.zdroje-grid-columns.pozadavekSmena.label",
  path: "pozadavekSmena",
  renderer: AnoNe
});
